import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const buttonV2DefaultVariants = {
  "variant": "quaternary"
}
const buttonV2CompoundVariants = []

const buttonV2SlotNames = [
  [
    "root",
    "button-v2__root"
  ]
]
const buttonV2SlotFns = /* @__PURE__ */ buttonV2SlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, buttonV2DefaultVariants, getSlotCompoundVariant(buttonV2CompoundVariants, slotName))])

const buttonV2Fn = memo((props = {}) => {
  return Object.fromEntries(buttonV2SlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const buttonV2VariantKeys = [
  "variant"
]
const getVariantProps = (variants) => ({ ...buttonV2DefaultVariants, ...compact(variants) })

export const buttonV2 = /* @__PURE__ */ Object.assign(buttonV2Fn, {
  __recipe__: false,
  __name__: 'buttonV2',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: buttonV2VariantKeys,
  variantMap: {
  "variant": [
    "impact",
    "primary",
    "secondary",
    "tertiary",
    "quaternary"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, buttonV2VariantKeys)
  },
  getVariantProps
})